import React from 'react';
import _ from 'lodash';
import { Line as LineChart, Bar as BarChart, defaults } from 'react-chartjs-2';
import AsthmaControlChart from './AsthmaControlChart';

import 'chartjs-plugin-datalabels';
import zoomer from 'chartjs-plugin-zoom';
import { saveAs } from './FileSaver';

const moment = require('moment');
const Api = require('./Config');

const NORMAL_TYPE = 'normaltype';
const BP_H = 'BP_H';
const BP_L = 'BP_L';
const SUGAR = 'sugar';
const VERTICAL = 'vertical';
const GRAPH = 'GRAPH';
const DAYS = 'DAYS';
const EAT_OUT = 'EAT_OUT';
const EAT_GOOD = 'EAT_GOOD';
const OXYGEN = 'OXYGEN';
const FEVER = 'FEVER';
const PEAK_FLOW = 'PEAK_FLOW';
const AST_CONTROL = 'AST_CONTROL';
const PHQ9 = 'PHQ9';
const FIBSER = 'FIBSER';
const WEIGHT = 'WEIGHT';

export default class DASReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_ref: props.patient_ref,
      patient_name: 'Some Patient',
      print_date: moment(new Date()).format('MM/DD/YY'),
      weight_baseline: null,
    };
  }

  getAlertIcon(alert) {
    if (alert == '-') {
      return '-';
    }
    if (alert == '!') {
      return <img src={`${Api.getHost()}docportal_api/critical.svg`} height={20} />;
    }
    if (alert == '*') {
      return <img src={`${Api.getHost()}docportal_api/warning.svg`} height={20} />;
    }
    if (alert == '!!!') {
      return <img src={`${Api.getHost()}docportal_api/emergency.svg`} height={20} />;
    }
  }

  formatDate(stDate) {
    if (stDate) {
      const dt = moment(stDate);
      return dt.format('MM/DD/YY');
    }
    return '';
  }

  getSlicedData(data, max = 14) {
    data = _.orderBy(data, ['acknowledged_on'], ['asc']);
    data = data.reverse();

    data = _.slice(data, 0, max);
    data = data.reverse();
    return data;
  }

  processDataFever({ all_result }) {
    let oxygen = _.filter(all_result, (a) => {
      if (a.type == OXYGEN) {
        return true;
      }
    });
    oxygen = this.getSlicedData(oxygen, 30);
    oxygen = _.map(oxygen, (a) => a.answer);

    const fever_orgi = _.filter(all_result, (a) => {
      if (a.type == FEVER) {
        return true;
      }
    });
    let fever = this.getSlicedData(fever_orgi, 30);
    const DATES = _.map(fever, (a) => a.short_date);
    fever = _.map(fever, (a) => a.answer);

    this.setState({ fever: { DATES, oxygen, fever } });
  }

  processDataDMB({ all_result }) {
    let has_adherance = false;
    let sugar = _.filter(all_result, (a) => {
      has_adherance = has_adherance || a.adherance == 'Y';
      if (a.type == SUGAR) {
        return true;
      }
    });

    sugar = this.getSlicedData(sugar);

    const DATES = _.map(sugar, (a) => a.short_date);
    sugar = _.map(sugar, (a) => a.answer);

    let ADS_SUGAR = _.filter(all_result, (a) => {
      if (a.type == DAYS && a.category == 'DMB') {
        return true;
      }
    });

    ADS_SUGAR = this.getSlicedData(ADS_SUGAR);

    ADS_SUGAR = _.map(ADS_SUGAR, (a) => {
      return Api.getDayValue(a.answer);
    });

    const sugar_sum = sugar.reduce((acc, item) => {
      acc += parseInt(item);
      return acc;
    }, 0);

    const AVG_SUGAR = sugar_sum / sugar.length;

    this.setState({ dmb: { DATES, ADS_SUGAR, sugar, AVG_SUGAR, has_adherance } });
  }

  processDataAST({ all_result }) {
    let has_adherance = false;

    // Get PEAK_FLOW type data points
    let peak_flow = _.filter(all_result, (a) => {
      has_adherance = has_adherance || a.adherance == 'Y';
      if (a.type == PEAK_FLOW) {
        return true;
      }
    });

    peak_flow = this.getSlicedData(peak_flow);
    const DATES = _.map(peak_flow, (a) => a.short_date);
    peak_flow = _.map(peak_flow, (a) => a.answer);

    // Get DAYS type data points
    let ADS_PEAK_FLOW = _.filter(all_result, (a) => {
      if (a.type == DAYS && a.category == 'AST') {
        return true;
      }
    });

    ADS_PEAK_FLOW = this.getSlicedData(ADS_PEAK_FLOW);
    const ADS_PEAK_FLOW_DATES = _.map(ADS_PEAK_FLOW, (a) => a.short_date);
    ADS_PEAK_FLOW = _.map(ADS_PEAK_FLOW, (a) => {
      return Api.getDayValue(a.answer);
    });

    // Get AST_CONTROL
    let ast_control_items = _.filter(all_result, (a) => {
      return a.type == AST_CONTROL;
    });

    let items_by_date = ast_control_items.reduce((acc, item) => {
      if (acc[item.acknowledged_on] == null) {
        acc[item.acknowledged_on] = [];
      }

      acc[item.acknowledged_on].push(item);
      return acc;
    }, {});

    let ast_control_dates = [];
    let ast_control = [];

    _.each(items_by_date, (group) => {
      ast_control_dates.push(group[0].short_date);
      ast_control.push({
        answer: Api.getAstControlValue(group),
        short_date: group[0].short_date,
        acknowledged_on: group[0].acknowledged_on,
      });
    });

    ast_control = this.getSlicedData(ast_control);

    this.setState({
      ast: { DATES, ADS_PEAK_FLOW, ADS_PEAK_FLOW_DATES, peak_flow, has_adherance, ast_control, ast_control_dates },
    });
  }

  processDataDEP({ all_result }, has_phq8) {
    // Get PHQ9 items
    const phq9_items = _.filter(all_result, (a) => {
      return a.type == PHQ9;
    });

    const phq9_data = this.processDepByType(phq9_items, 'phq9');

    // Get FIBSER items
    const fibser_items = _.filter(all_result, (a) => {
      return a.type == FIBSER;
    });

    const fibser_data = this.processDepByType(fibser_items, 'fibser');

    this.setState({
      dep: {
        phq9_dates: phq9_data.dates,
        phq9: phq9_data.formattedItems,
        phq9_label: has_phq8 ? 'PHQ-8' : 'PHQ-9',
        fibser_dates: fibser_data.dates,
        fibser: fibser_data.formattedItems,
      },
    });
  }

  processDepByType(items, type) {
    let items_by_date = items.reduce((acc, item) => {
      if (acc[item.acknowledged_on] == null) {
        acc[item.acknowledged_on] = [];
      }

      acc[item.acknowledged_on].push(item);
      return acc;
    }, {});

    let dates = [];
    let formattedItems = [];

    _.each(items_by_date, (group) => {
      dates.push(group[0].short_date);
      formattedItems.push({
        answer: Api.getDepressionScore(group, type),
        short_date: group[0].short_date,
        acknowledged_on: group[0].acknowledged_on,
      });
    });

    formattedItems = this.getSlicedData(formattedItems);

    return {
      dates: dates,
      formattedItems: formattedItems,
    };
  }

  processDataFood({ all_result }) {
    let good_food = _.filter(all_result, (a) => {
      if (a.type == EAT_GOOD) {
        return true;
      }
    });
    good_food = this.getSlicedData(good_food);
    good_food = _.map(good_food, (a) => a.answer);

    const bad_food_orgi = _.filter(all_result, (a) => {
      if (a.type == EAT_OUT) {
        return true;
      }
    });
    let bad_food = this.getSlicedData(bad_food_orgi);
    const DATES = _.map(bad_food, (a) => a.short_date);
    bad_food = _.map(bad_food, (a) => a.answer);

    this.setState({ food: { DATES, good_food, bad_food } });
  }

  processDataHTN({ all_result }) {
    let has_adherance = false;
    let BP_HS = _.filter(all_result, (a) => {
      has_adherance = has_adherance || a.adherance == 'Y';
      if (a.type == BP_H) {
        return true;
      }
    });
    BP_HS = this.getSlicedData(BP_HS);
    BP_HS = _.map(BP_HS, (a) => a.answer);
    const bp_hs_sum = BP_HS.reduce((acc, item) => {
      acc += parseInt(item);
      return acc;
    }, 0);
    const AVG_BP_HS = bp_hs_sum / BP_HS.length;

    let BP_LS = _.filter(all_result, (a) => {
      if (a.type == BP_L) {
        return true;
      }
    });
    const BP_LS_SORTED = this.getSlicedData(BP_LS);
    BP_LS = _.map(BP_LS_SORTED, (a) => a.answer);
    const bp_ls_sum = BP_LS.reduce((acc, item) => {
      acc += parseInt(item);
      return acc;
    }, 0);
    const AVG_BP_LS = bp_ls_sum / BP_LS.length;

    let ADS_BP = _.filter(all_result, (a) => {
      if (a.type == DAYS && a.category == 'HTN') {
        return true;
      }
    });
    ADS_BP = this.getSlicedData(ADS_BP);

    let DATES = _.map(ADS_BP, (a) => a.short_date);
    if (this.state.data.has_guard_rail == 'yes') {
      DATES = _.map(BP_LS_SORTED, (a) => a.short_date);
    }

    ADS_BP = _.map(ADS_BP, (a) => {
      return Api.getDayValue(a.answer);
    });

    this.setState({
      bp: {
        DATES,
        ADS_BP,
        BP_HS,
        BP_LS,
        has_adherance,
        AVG_BP_HS,
        AVG_BP_LS,
      },
    });
  }

  processDataWeight({ all_result }) {
    let weight = _.filter(all_result, (a) => {
      if (a.type == WEIGHT) {
        return true;
      }
    });
    weight = this.getSlicedData(weight, 6);
    const weightAnswer = _.map(weight, (a) => a.answer);
    const DATES = _.map(weight, (a) => a.short_date);
    this.setState({ weight: { DATES, weight: weightAnswer } });
  }

  componentDidMount() {
    // historic graphing - show points in the graph before the sent in date of the selected encounter
    Api.getDasReport(this.props.patient_ref || '20180803HRS', this.props.faxMode, this.props.sentInDate)
      .then((data) => {
        this.setState({ data });
        const { t_codes } = data;
        const has_bp = _.find(t_codes, (a) => a.category == 'HTN');
        const has_sugar = _.find(t_codes, (a) => a.category == 'DMB');
        const has_peak_flow = _.find(t_codes, (a) => a.category == 'AST');
        const has_phq9_fibser = _.find(t_codes, (a) => a.category == 'DEP');
        const has_weight = _.find(t_codes, (a) => a.category == 'HTN');
        const has_food_graph = _.find(t_codes, (a) => a.FOOD_GRAPH === true);
        const has_fever_oxygen_graph = _.find(t_codes, (a) => a.FEVER_OXYGEN_GRAPH === true);
        const has_phq8 = _.find(t_codes, (a) => a.JID == 30);
        if (data.all_result.length > 0) {
          has_food_graph && this.processDataFood(data);
          has_bp && this.processDataHTN(data);
          has_sugar && this.processDataDMB(data);
          has_fever_oxygen_graph && this.processDataFever(data);
          has_peak_flow && this.processDataAST(data);
          has_phq9_fibser && this.processDataDEP(data, has_phq8);
          has_weight && this.processDataWeight(data);
        }

        if (has_weight) {
          let tcodeWeightBaseline = null;
          let tcodeData;

          if (this.props.currentTcode) {
            tcodeData = _.find(t_codes, (a) => a.t_code == this.props.currentTcode);
            tcodeWeightBaseline = tcodeData.weight_baseline;
          } else {
            tcodeData = t_codes.filter((item) => item.weight_baseline);
            if (tcodeData.length) {
              tcodeWeightBaseline = tcodeData[0].weight_baseline;
            }
          }

          this.setState({ weight_baseline: tcodeWeightBaseline });
        }
      })
      .catch((err) => {
        window.status = 'DONE';
        console.log(err);
      });
  }

  render() {
    if (!this.state.data) {
      return <div>...</div>;
    }

    let flagged_responses = [];
    if (this.state.data.fagged_responses) {
      flagged_responses = _.orderBy(this.state.data.fagged_responses, ['acknowledged_on'], ['desc']);
    }

    if (this.props.faxMode == true) {
      setTimeout(() => {
        window.status = 'DONE';
      }, 3000);

      return (
        <div>
          <div>{this.state.bp && this.props.category == 'HTN' && this.getBPChart()}</div>

          <div style={{ marginTop: 10 }}>{this.state.dmb && this.props.category == 'DMB' && this.getSugarChart()}</div>

          <div style={{ marginTop: 10 }}>{this.state.ast && this.props.category == 'AST' && this.getASTChart()}</div>

          <div style={{ marginTop: 10 }}>{this.state.dep && this.props.category == 'DEP' && this.getDEPChart()}</div>

          <div style={{ marginTop: 10 }}>{this.state.weight && this.getWeightChart()}</div>

          <div style={{ marginTop: 10 }}>{this.state.food && this.getFoodChart()}</div>

          <div style={{ marginTop: 10 }}>
            {this.state.fever && ['CVD', 'AVI'].includes(this.props.category) && this.getFeverChart()}
          </div>
        </div>
      );
    }

    return (
      <div>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 'bold' }}>
              Data & Analysis, Summary Report - {this.state.print_date}
            </div>
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>
              {this.props.print_name} - {this.state.data.patient.yob}{' '}
            </div>
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>
              PT REF#:
              {this.state.data.patient_ref}-{this.props.dr_ref}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 'bold' }}>Journey Progress</div>
            <div>
              <table style={{ fontSize: 11 }} className="table table-striped table-condensed">
                <thead>
                  <tr>
                    <th>Journey</th>
                    <th>T-Code</th>
                    <th>Start</th>
                    <th>Last</th>
                  </tr>
                </thead>
                <tbody>
                  {_.map(this.state.data.t_codes, (t_code, index) => {
                    let last_message = _.get(t_code, 'last_message', {});
                    if (last_message == null) {
                      last_message = {};
                    }
                    const st = {};
                    if (last_message.acknowledged == 'Y') {
                      st.color = 'red';
                    }

                    return (
                      <tr>
                        <td>{t_code.category}</td>
                        <td>{t_code.t_code}</td>
                        <td>{this.formatDate(t_code.journey_start_date)}</td>
                        <td style={st}>{this.formatDate(last_message.sent_date)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="text-center" style={{ fontSize: 20, fontWeight: 'bold' }}>
          Recent Flagged Responses
        </div>
        <div>
          <table className="table table-striped table-condensed">
            <tbody>
              {_.map(flagged_responses, (single, index) => {
                const ans = Api.getAnswerFormated(single.answer);
                let anwerhtml = '<span>' + ans[0] + '</span>';
                if (ans[1] == true) {
                  anwerhtml = "<img height='40' width='40' src='" + ans[0] + "'/>";
                }
                return (
                  <tr>
                    <td>{single.category}</td>
                    <td>{this.formatDate(single.acknowledged_on)}</td>
                    <td>{single.question}</td>
                    <td>
                      {ans[1] == true && <img height={40} width={40} src={ans[0]} />}
                      {ans[1] == false && <span>{ans[0]}</span>}
                    </td>
                    <td style={{ textAlign: 'right' }}>{this.getAlertIcon(single.alert)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingLeft: 30,
            paddingRight: 30,
          }}
        >
          {this.state.data.has_guard_rail == 'yes' && (
            <table className="table table-condensed" style={{ width: 400 }}>
              <thead>
                <tr>
                  {this.state.data.guard_rail.low_emergency && <th>Low Emergency</th>}
                  <th>Low Critical</th>
                  <th>Low Warning</th>
                  {this.state.data.guard_rail.high_warning && <th>High Warning</th>}
                  {this.state.data.guard_rail.high_alert && <th>High Critical</th>}
                  {this.state.data.guard_rail.high_emergency && <th>High Emergency</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {this.state.data.guard_rail.low_emergency && <td>{this.state.data.guard_rail.low_emergency}</td>}
                  <td>{this.state.data.guard_rail.low_alert}</td>
                  <td>{this.state.data.guard_rail.low_warning}</td>
                  {this.state.data.guard_rail.high_warning && <td>{this.state.data.guard_rail.high_warning}</td>}
                  {this.state.data.guard_rail.high_alert && <td>{this.state.data.guard_rail.high_alert}</td>}
                  {this.state.data.guard_rail.high_emergency && <td>{this.state.data.guard_rail.high_emergency}</td>}
                </tr>
              </tbody>
            </table>
          )}
          <div>
            {this.state.bp && (
              <>
                <div>
                  <strong>Average Systolic: {this.state.bp.AVG_BP_HS.toFixed(2)}</strong>
                </div>
                <div>
                  <strong>Average Diastolic: {this.state.bp.AVG_BP_LS.toFixed(2)}</strong>
                </div>
              </>
            )}
            {this.state.dmb && (
              <div>
                <strong>Average Blood Sugar: {this.state.dmb.AVG_SUGAR.toFixed(2)}</strong>
              </div>
            )}
          </div>
        </div>

        <div>{this.state.bp && this.getBPChart()}</div>
        <div style={{ marginTop: 10 }}>{this.state.ast && this.getASTChart()}</div>
        <div style={{ marginTop: 10 }}>{this.state.dep && this.getDEPChart()}</div>
        <div style={{ marginTop: 10 }}>{this.state.dmb && this.getSugarChart()} </div>
        <div style={{ marginTop: 10 }}>{this.state.food && this.getFoodChart()} </div>
        <div style={{ marginTop: 10 }}>{this.state.fever && this.getFeverChart()} </div>
        <div style={{ marginTop: 10 }}>{this.state.weight && this.getWeightChart()}</div>
      </div>
    );
  }

  getSugarChart() {
    // nothing to show
    if (this.state.dmb.DATES.length <= 0) {
      return;
    }

    let title = 'DM Biometrics and adherence';
    let dm_data_set = [
      {
        label: 'Blood Glucose',
        type: 'line',
        borderColor: '#ad37fb',
        backgroundColor: '#ad37fb',
        borderWidth: 5,
        data: this.state.dmb.sugar,
        fill: false,
      },
      {
        label: 'Adherence',
        type: 'bar',
        backgroundColor: '#c4e57e',
        backgroundColorHover: '#3e95cd',
        data: this.state.dmb.ADS_SUGAR,
        yAxisID: 'y-axis-2',
        datalabels: {
          labels: {
            title: null,
          },
        },
      },
    ];

    let min = _.min(_.map(this.state.dmb.sugar, (a) => parseInt(a))) - 20;
    min = min + (10 - (min % 10));

    // left axis shouldn't extend lower than 30
    if (min < 30) {
      min = 30;
    }

    let max = _.max(_.map(this.state.dmb.sugar, (a) => parseInt(a))) + 20;
    max = max + (10 - (max % 10));

    let dm_axis = [
      {
        ticks: {
          min,
          max,
        },
        scaleLabel: {
          display: true,
          labelString: 'Blood Glucose (mm/dl)',
        },
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'left',
        id: 'y-axis-1',
      },
      {
        scaleLabel: {
          display: true,
          labelString: 'Adherence (days)',
        },
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'right',
        id: 'y-axis-2',
        ticks: {
          suggestedMin: 0, // minimum will be 0, unless there is a lower value.
          suggestedMax: 7,
          beginAtZero: true, // minimum value will be 0.
        },
        gridLines: {
          drawOnChartArea: false,
        },
      },
    ];

    if (this.state.dmb.has_adherance === false) {
      title = 'DM Biometrics';
      dm_data_set = [
        {
          label: 'Blood Glucose',
          type: 'line',
          borderColor: '#ad37fb',
          backgroundColor: '#ad37fb',
          borderWidth: 5,
          data: this.state.dmb.sugar,
          fill: false,
          yAxisID: 'y-axis-2',
        },
      ];
      dm_axis = [
        dm_axis[0],
        {
          ticks: {
            min,
            max,
          },
          scaleLabel: {
            display: true,
            labelString: 'Blood Glucose (mm/dl)',
          },
          type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
          display: true,
          position: 'right',
          id: 'y-axis-2',
        },
      ];
    }

    return (
      <BarChart
        height={140}
        data={{
          labels: this.state.dmb.DATES,
          datasets: dm_data_set,
        }}
        options={{
          animation: false,
          title: {
            display: true,
            fontSize: 25,
            text: title,
          },
          legend: {
            display: this.state.data.has_guard_rail != 'yes',
            position: 'bottom',
            onClick: () => {},
          },
          scales: {
            yAxes: dm_axis,
          },
          plugins: {
            datalabels: {
              offset: 5,
              align: 'top',
            },
          },
        }}
      />
    );
  }

  getWeightChart() {
    // nothing to show
    if (this.state.weight.DATES.length <= 0) {
      return;
    }

    return (
      <div className="main-table-weight" style={{ marginTop: 10 }}>
        <div style={{ padding: 20, textAlign: 'center' }}>
          <span style={{ fontSize: 24, fontWeight: 'bold', color: '#666666' }}>Weight</span>
        </div>
        <div className="row" style={{ paddingLeft: 20, paddingRight: 20 }}>
          <div className="col-xs-4 table-weight-baseline">
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Baseline Weight</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{this.state.weight_baseline}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-xs-8 table-weight">
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Weight</th>
                </tr>
              </thead>
              <tbody>
                {_.map(this.state.weight.weight, (weightItem, index) => {
                  return (
                    <tr>
                      <td>{this.state.weight.DATES[index]}</td>
                      <td>{weightItem}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  getASTChart() {
    // nothing to show
    if (this.state.ast.DATES.length <= 0) {
      return;
    }

    return (
      <div>
        {this.state.ast.peak_flow &&
          this.getPeakFlowChart(this.state.ast.peak_flow, this.state.ast.DATES, this.state.data.has_guard_rail)}
        {this.state.ast.ADS_PEAK_FLOW.length > 0 &&
          this.getAdheranceChart(
            this.state.ast.ADS_PEAK_FLOW,
            this.state.ast.ADS_PEAK_FLOW_DATES,
            this.state.data.has_guard_rail,
            'Asthma Adherance'
          )}
        {this.state.ast.ast_control.length > 0 &&
          this.getAsthmaControlChart(this.state.ast.ast_control, this.state.ast.ast_control_dates)}
      </div>
    );
  }

  getPeakFlowChart(peak_flow, dates, has_guard_rail) {
    let min = _.min(_.map(peak_flow, (a) => parseInt(a))) - 20;
    min = min + (10 - (min % 10));

    let max = _.max(_.map(peak_flow, (a) => parseInt(a))) + 20;
    max = max + (10 - (max % 10));

    let title = 'Asthma Biometrics';
    let dm_data_set = [
      {
        label: 'Peak Flow',
        type: 'line',
        borderColor: '#ad37fb',
        backgroundColor: '#ad37fb',
        borderWidth: 5,
        data: peak_flow,
        fill: false,
        yAxisID: 'y-axis-1',
      },
    ];

    let dm_axis = [
      {
        ticks: {
          min,
          max,
        },
        scaleLabel: {
          display: true,
          labelString: 'Peak Flow',
        },
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'left',
        id: 'y-axis-1',
      },
    ];

    return (
      <BarChart
        height={140}
        data={{
          labels: dates,
          datasets: dm_data_set,
        }}
        options={{
          animation: false,
          title: {
            display: true,
            fontSize: 25,
            text: title,
          },
          legend: {
            display: has_guard_rail != 'yes',
            position: 'bottom',
            onClick: () => {},
          },
          scales: {
            yAxes: dm_axis,
          },
          plugins: {
            datalabels: {
              offset: 5,
              align: 'top',
            },
          },
        }}
      />
    );
  }

  getAdheranceChart(adherance, dates, has_guard_rail, title) {
    let dm_data_set = [
      {
        label: 'Adherence',
        type: 'bar',
        backgroundColor: '#c4e57e',
        backgroundColorHover: '#3e95cd',
        data: adherance,
        yAxisID: 'y-axis-1',
        datalabels: {
          labels: {
            title: null,
          },
        },
      },
    ];

    let dm_axis = [
      {
        scaleLabel: {
          display: true,
          labelString: 'Adherence (days)',
        },
        type: 'linear',
        display: true,
        position: 'left',
        id: 'y-axis-1',
        ticks: {
          suggestedMin: 0,
          suggestedMax: 7,
          beginAtZero: true,
        },

        gridLines: {
          drawOnChartArea: false,
        },
      },
    ];

    return (
      <div style={{ marginTop: 10 }}>
        <BarChart
          height={140}
          data={{
            labels: dates,
            datasets: dm_data_set,
          }}
          options={{
            animation: false,
            title: {
              display: true,
              fontSize: 25,
              text: title,
            },
            legend: {
              display: has_guard_rail != 'yes',
              position: 'bottom',
              onClick: () => {},
            },
            scales: {
              xAxes: [
                {
                  maxBarThickness: 100,
                },
              ],
              yAxes: dm_axis,
            },
          }}
        />
      </div>
    );
  }

  getAsthmaControlChart(ast_control, dates) {
    ast_control = ast_control.map((item) => item.answer);

    let dm_data_set = [
      {
        label: 'Asthma Control',
        type: 'line',
        borderColor: '#ad37fb',
        backgroundColor: '#ad37fb',
        borderWidth: 5,
        data: ast_control,
        lineTension: 0,
        fill: false,
      },
    ];

    return (
      <div style={{ marginTop: 10 }}>
        <AsthmaControlChart data={{ labels: dates, datasets: dm_data_set }} title="Asthma Control" leftPadding={0} />
      </div>
    );
  }

  getDEPChart() {
    return (
      <div>
        {this.state.dep.phq9.length > 0 &&
          this.getPhq9Chart(this.state.dep.phq9, this.state.dep.phq9_dates, this.state.dep.phq9_label)}
        {this.state.dep.fibser.length > 0 && this.getFibserChart(this.state.dep.fibser, this.state.dep.fibser_dates)}
      </div>
    );
  }

  getPhq9Chart(phq9, dates, label) {
    phq9 = phq9.map((item) => item.answer);

    let phq9_data_set = [
      {
        label: label,
        fill: true,
        backgroundColor: 'rgba(0,49,229,.5)',
        borderColor: 'rgba(0,49,229,.5)',
        data: phq9,
        datalabels: {
          labels: {
            title: null,
          },
        },
      },
    ];

    return (
      <div style={{ marginTop: 10 }}>
        <BarChart
          height={140}
          data={{
            labels: dates,
            datasets: phq9_data_set,
          }}
          options={{
            animation: false,
            title: {
              display: true,
              fontSize: 25,
              text: label,
            },
            legend: {
              display: false,
            },
            scales: {
              xAxes: [
                {
                  maxBarThickness: 100,
                },
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          }}
        />
      </div>
    );
  }

  getFibserChart(fibser, dates) {
    fibser = fibser.map((item) => item.answer);

    let fibser_data_set = [
      {
        label: 'FIBSER',
        fill: true,
        backgroundColor: 'rgba(0,49,229,.5)',
        borderColor: 'rgba(0,49,229,.5)',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointRadius: 5,
        pointHitRadius: 10,
        lineTension: 0,
        data: fibser,
      },
    ];

    return (
      <div style={{ marginTop: 10 }}>
        <LineChart
          height={140}
          data={{
            labels: dates,
            datasets: fibser_data_set,
          }}
          options={{
            animation: false,
            title: {
              display: true,
              fontSize: 25,
              text: 'FIBSER',
            },
            legend: {
              display: false,
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 6,
                  },
                },
              ],
              xAxes: [
                {
                  offset: 1,
                },
              ],
            },
            plugins: {
              datalabels: {
                offset: 5,
                align: 'top',
              },
            },
          }}
        />
      </div>
    );
  }

  getFeverChart() {
    return (
      <BarChart
        height={140}
        data={{
          labels: this.state.fever.DATES,

          datasets: [
            {
              label: 'Temperature',
              type: 'line',
              borderWidth: 5,
              backgroundColor: '#AB0D22',
              borderColor: '#AB0D22',
              data: this.state.fever.fever,
              yAxisID: 'y-axis-1',
              fill: false,
              order: 0,
            },
            {
              label: '%SpO2',
              type: 'bar',
              width: 20,
              borderColor: '#A4B370',
              backgroundColor: '#A4B370',
              borderWidth: 5,
              data: this.state.fever.oxygen,
              yAxisID: 'y-axis-2',
              fill: false,
              order: 1,
              datalabels: {
                labels: {
                  title: null,
                },
              },
            },
          ],
        }}
        options={{
          animation: false,
          title: {
            display: true,
            fontSize: 25,
            text: 'Temperature & %SpO2',
          },
          legend: {
            display: true,
            position: 'bottom',
            reverse: true,
            onClick: () => {},
          },
          scales: {
            xAxes: [
              {
                barPercentage: 0.5,
              },
            ],
            yAxes: [
              {
                ticks: {
                  max: 100,
                  min: 80,
                },
                scaleLabel: {
                  display: true,
                  labelString: '%SpO2',
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'left',
                id: 'y-axis-2',
              },
              {
                ticks: {
                  max: 108,
                  min: 95,
                  stepSize: 0.5,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Temperature °F',
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'right',
                id: 'y-axis-1',
              },
            ],
          },
          plugins: {
            datalabels: {
              offset: 5,
              align: 'top',
            },
          },
        }}
      />
    );
  }

  getFoodChart() {
    return (
      <BarChart
        height={140}
        data={{
          labels: this.state.food.DATES,
          datasets: [
            {
              label: 'Eating Out',
              type: 'line',
              borderWidth: 5,
              backgroundColor: '#AB0D22',
              borderColor: '#AB0D22',
              data: this.state.food.bad_food,
              fill: false,
            },
            {
              label: 'Fruits/Veg',
              type: 'bar',
              width: 20,
              borderColor: '#A4B370',
              backgroundColor: '#A4B370',
              borderWidth: 5,
              data: this.state.food.good_food,
              fill: false,
            },
          ],
        }}
        options={{
          animation: false,
          title: {
            display: true,
            fontSize: 25,
            text: 'Nutrition ',
          },
          legend: {
            display: true,
            position: 'bottom',
            onClick: () => {},
          },
          scales: {
            xAxes: [
              {
                barPercentage: 0.2,
              },
            ],
            yAxes: [
              {
                ticks: {
                  suggestedMax: 3,
                  suggestedMin: 0,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Time(s) a day',
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'left',
                id: 'y-axis-1',
              },
              {
                ticks: {
                  suggestedMax: 3,
                  suggestedMin: 0,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Time(s) a day',
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'right',
                id: 'y-axis-2',
              },
            ],
          },
          plugins: {
            datalabels: {
              display: false,
            },
          },
        }}
      />
    );
  }

  getBPChart() {
    // nothing to show
    if (this.state.bp.DATES.length <= 0) {
      return;
    }

    let min = _.min(_.map(this.state.bp.BP_LS, (a) => parseInt(a))) - 20;
    min = min + (10 - (min % 10));
    let max = _.max(_.map(this.state.bp.BP_HS, (a) => parseInt(a))) + 20;
    max = max + (10 - (max % 10));

    if (this.state.bp.has_adherance === false) {
      return (
        <BarChart
          height={140}
          data={{
            labels: this.state.bp.DATES,
            datasets: [
              {
                label: 'Systolic',
                type: 'line',
                borderWidth: 5,
                backgroundColor: '#fa2428',
                borderColor: '#fa2428',
                data: this.state.bp.BP_HS,
                fill: false,
              },
              {
                label: 'Diastolic',
                type: 'line',
                borderColor: '#0b35fb',
                backgroundColor: '#0b35fb',
                borderWidth: 5,
                data: this.state.bp.BP_LS,
                fill: false,
              },
            ],
          }}
          options={{
            animation: false,
            title: {
              display: true,
              fontSize: 25,
              text: 'HTN Biometrics ',
            },
            legend: {
              display: true,
              position: 'bottom',
              onClick: () => {},
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    min,
                    max,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Blood Pressure (mmhg)',
                  },
                  type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: 'left',
                  id: 'y-axis-1',
                },
                {
                  ticks: {
                    min,
                    max,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Blood Pressure (mmhg)',
                  },
                  type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: 'right',
                  id: 'y-axis-2',
                },
              ],
            },
            plugins: {
              datalabels: {
                offset: 5,
                align: 'top',
              },
            },
          }}
        />
      );
    }

    return (
      <BarChart
        height={140}
        data={{
          labels: this.state.bp.DATES,
          datasets: [
            {
              label: 'Systolic',
              type: 'line',
              borderWidth: 5,
              backgroundColor: '#fa2428',
              borderColor: '#fa2428',
              data: this.state.bp.BP_HS,
              fill: false,
            },
            {
              label: 'Diastolic',
              type: 'line',
              borderColor: '#0b35fb',
              backgroundColor: '#0b35fb',
              borderWidth: 5,
              data: this.state.bp.BP_LS,
              fill: false,
            },
            {
              label: 'Adherence',
              type: 'bar',
              backgroundColor: '#c4e57e',
              backgroundColorHover: '#3e95cd',
              data: this.state.bp.ADS_BP,
              yAxisID: 'y-axis-2',
              datalabels: {
                labels: {
                  title: null,
                },
              },
            },
          ],
        }}
        options={{
          animation: false,
          title: {
            display: true,
            fontSize: 25,
            text: 'HTN Biometrics and adherence',
          },
          legend: {
            display: true,
            position: 'bottom',
            onClick: () => {},
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  suggestedMax: _.max(_.map(this.state.bp.BP_HS, (a) => parseInt(a))) + 20,
                  suggestedMin: _.min(_.map(this.state.bp.BP_LS, (a) => parseInt(a))) - 20,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Blood Pressure (mmhg)',
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'left',
                id: 'y-axis-1',
              },
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Adherence (days)',
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'right',
                id: 'y-axis-2',
                ticks: {
                  suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                  suggestedMax: 7,
                  beginAtZero: true, // minimum value will be 0.
                },
                gridLines: {
                  drawOnChartArea: false,
                },
              },
            ],
          },
          plugins: {
            datalabels: {
              offset: 5,
              align: 'top',
            },
          },
        }}
      />
    );
  }
}
